export default "__VITE_ASSET__a35ec1dd__"